// extracted by mini-css-extract-plugin
module.exports = {"heart":"HeartRating-heart-2I0uM"};